<div class="r-content betslip">
    <ng-content />
    <div class="ctn-title">
        <div class="title">
            <span>{{stepNumber}}</span>
            <p>{{"betslip.title.choice" | translate }}</p>
        </div>
        <button
            type="button"
            class="btn btn-delete"
            (click)="deleteBet()">
            <!-- [disabled]="!isHorseSelected" -->
            <img src="images/svg/delete.svg" alt="Delete">
            {{'delete_all' | translate}}
        </button>
    </div>
    <div class="ctn-betslip">
        @if (pari) {
        <div class="ctn-b-course">
            <h2 class="c-title">{{ raceShortNameFormat }}</h2>
            <h3 class="c-title">{{ raceFullNameFormat }}</h3>
            <p class="c-title">
                {{ race?.type }} - {{ raceDistanceStr }} - {{ horsesCountString }}
                @if (pari.prize) {
                    - {{ pari.prize | currencyFormatter }}
                }
                - {{ pari.race?.date | date:"HH'h'mm" }}
            </p>
        </div>
        <hr>
        <div class="g-typ">
            <div class="type">{{"betslip.bet" | translate}}</div>
            <strong class="game">{{ pari.game?.code }}</strong>
            <p class="select-num">{{ formattedSelectionStr }}</p>
            <p class="combines">{{"betslip.number_of_combinations" | translate}}:</p>
            <strong class="count">{{pari.nCombine}}</strong>
        </div>
        <hr>
        <div class="stake">
            {{"betslip.stake.label" | translate}}<br>
            <strong>{{ pari.mise | currencyFormatter:true}}</strong>
        </div>
        <hr>
        @if(showCalculatedStakeWithoutTax){
            <div class="amount">
                {{"betslip.stake.amount" | translate}}<br>
                <strong>{{ pari.montant | currencyFormatter:true}}</strong>
            </div>
            <hr>
        }
        <div class="amount payable">
            {{"betslip.stake.payable" | translate}}<br>
            <strong>{{ pari.payable | currencyFormatter:true }}</strong>
        </div>
        }
        @if(showFormulCompletChecker){
            <hr>
            <div class="cf-toggler mt-2">
                <input class="form-check-input btn btn-secondary" type="checkbox"
                    [(ngModel)]="cfVal" value=""
                    id="{{pari.game?.name}}-option-{{(pari.game?.formulas?.length || 0) + 1}}"
                    [disabled]="!validCombine"
                    (change)="toggleCompleteFormula()">
                <label class="form-check-label" for="{{pari.game?.name}}-option-{{(pari.game?.formulas?.length || 0) + 1}}">
                   {{'formula.CF' | translate}}
                </label>

            </div>
        }
        <form [formGroup]="betSlipForm" class="betslip-form">
            @if (options.operators && options.operators.length > 0) {
                <div class="btn-group btn-group-toggle payment-method" data-toggle="buttons">
                    @for (operator of options.providers; track $index; let i = $index) {
                        @if (operator) {
                            <label class="btn btn-secondary btn-provider"
                                matRipple
                                [matRippleCentered]="operatorsRippleOptions.centered"
                                [matRippleDisabled]="operatorsRippleOptions.disabled"
                                [matRippleUnbounded]="operatorsRippleOptions.unbounded"
                                [matRippleRadius]="operatorsRippleOptions.radius"
                                [matRippleColor]="operatorsRippleOptions.color"
                                (click)="setProvider(operator)"
                                [class.active]="providerIsSelected(operator)">
                                <img class="provider__logo" src="images/png/provider/{{getProviderIconName(operator)}}" alt="{{operator.desc}}">
                            </label>
                        }
                    }
                </div>

            }
            <div class="phone-num-zone">
                <label for="basic-url">{{"phone_number" | translate}}</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <select style="background-image: url(images/svg/chevron-down.svg);"
                            class="form-control form-control-lg" name="country" (change)="onCountrySelected($event)">
                            @for (ctry of options.countries; track $index) {
                                <option [value]="ctry.id" [selected]="isSelectedCountry(ctry)">+{{ctry.id}}</option>
                            }
                        </select>
                    </div>
                    <input type="tel" class="form-control form-control-lg" placeholder="{{'placeholder.phone_number_example' | translate}}"
                        formControlName="phoneNumber" name="phoneNumber"
                        aria-label="Votre numéro de téléphone" required />
                </div>
                @if (phoneErr.length > 0) {
                    <div class="err-msg">
                        {{phoneErr | translate}}
                    </div>
                }
            </div>
            <div class="btn-group betslip-submit w-100">
                <button
                    matRipple
                    [matRippleCentered]="submitBtnRippleOptions.centered"
                    [matRippleDisabled]="submitBtnRippleOptions.disabled"
                    [matRippleUnbounded]="submitBtnRippleOptions.unbounded"
                    [matRippleRadius]="submitBtnRippleOptions.radius"
                    [matRippleColor]="submitBtnRippleOptions.color"
                    [disabled]="disableSubmit()"
                    type="submit" (click)="validateBet()" class="btn btn-submit">{{"betslip.place_bet" | translate}}</button>
                    @if (errMsg.length > 0) {
                        <div class="err-msg">
                            {{errMsg | translate}}
                            error
                        </div>
                    }
            </div>
        </form>
      </div>
</div>

@if (notification){
 <app-notification-box
  [type]="notification.type || 'success'"
  [message]="notification.message || ''"
  (closed)="closeNotification()">
 </app-notification-box>
}
